module.exports = __webpack_public_path__ + "img/destinology.40262fe7.webp";